import { render } from "./MatchHistory.vue?vue&type=template&id=43d178cc"
import script from "./MatchHistory.vue?vue&type=script&lang=js"
export * from "./MatchHistory.vue?vue&type=script&lang=js"

import "./MatchHistory.vue?vue&type=style&index=0&id=43d178cc&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__